<template>
	<div class="section pt-0 mt-0">
		<!-- <div class="listed-detail mt-1 page-title">
			<h3 class="text-center mt-1 custom-title">Documents / Circulars</h3>
		</div> -->
		<!-- <form @submit.prevent="handleSearch" class="search-form mb-2">
			<input
				type="text"
				v-model="search"
				placeholder="Search documents..."
				class="form-control search-input"
			/>
			<button type="submit" class="btn btn-primary search-button">Search</button>
		</form> -->
	</div>
	<div class="section text-center" v-if="loading_page">
		<div class="spinner-border text-secondary" role="status"></div>
	</div>
	<div v-if="!loading_page">
		<ul class="listview image-listview inset mt-1" v-if="documents.length">
			<li v-for="doc in documents" :key="doc.id">
				<div class="item">
					<div class="icon-box bg-primary">
						<ion-icon name="document-outline" role="img" class="md hydrated" aria-label="document outline"></ion-icon>
					</div>
					<div class="in">
						<div>
							<div class="mb-05"><strong>{{doc.title}}</strong></div>
							<div class="text-small mb-05">{{doc.description}}</div>
							<div class="text-xsmall text-primary">{{doc.formatted_created_at || getFormattedDate(doc.created_at)}}</div>
						</div>
					</div>
					<div class="document-actions mt-1">
						<button @click="downloadDocument(doc.id, doc.file_name)" class="btn btn-sm btn-outline-primary mr-1" title="Download">
							<span style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
								<ion-icon name="download-outline" style="margin: auto;"></ion-icon>
							</span>
						</button>
						<button @click="viewDocument(doc.id)" class="btn btn-sm btn-outline-secondary" title="View">
							<span style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
								<ion-icon name="eye-outline" style="margin: auto;"></ion-icon>
							</span>
						</button>
					</div>
				</div>
			</li>
		</ul>
		<div v-else class="text-center text-muted py-4">
			No Circular Uploaded
		</div>
	</div>
	<alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
	<dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>

import UserService from "@/services/user.service";
import AlertModel from "@/views/layouts/AlertModel.vue";
import DialogModel from "@/views/layouts/DialogModel.vue";
import moment from 'moment';

export default {
	name: "DocumentList",
	components: {
		AlertModel,
		DialogModel,
	},
	data() {
		return {
			loading_page: false,
			alert_type: "",
			alert_message: "",
			dialog_message: "",
			dialog_action: "",
			dialog_action_params: [],
			documents: [],
			search: "",
			page: 1,
			per_page: 15,
		};
	},
	mounted() {
		this.getDocuments();
		this.$root.updateParent(this.$t('circulars'));
	},
	methods: {
		showAlert(type, message) {
			this.alert_type = type;
			this.alert_message = message;
			if (this.$refs.alert_model && this.$refs.alert_model.show) {
				this.$refs.alert_model.show();
			}
		},
		getFormattedDate(date) {
			return moment(date).format("DD-MM-YYYY");
		},
		getFileType(fileName) {
			if (!fileName) return 'application/octet-stream';
			
			const extension = fileName.toLowerCase().split('.').pop();
			const mimeTypes = {
				// PDF
				'pdf': 'application/pdf',
				// Microsoft Office Documents
				'doc': 'application/msword',
				'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'xls': 'application/vnd.ms-excel',
				'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'ppt': 'application/vnd.ms-powerpoint',
				'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				// Text files
				'txt': 'text/plain',
				// Images
				'jpg': 'image/jpeg',
				'jpeg': 'image/jpeg',
				'png': 'image/png',
				'gif': 'image/gif'
			};
			
			return mimeTypes[extension] || 'application/octet-stream';
		},
		getDocuments(searchQuery = "") {
			this.loading_page = true;
			let data = {
				per_page: this.per_page,
				page: this.page,
				search: searchQuery
			};
			UserService.authGetRequest('documents', data).then(
				(response) => {
					console.log('Full response:', response);
					const payload = response && response.data ? response.data : {};
					const isSuccess = payload.success === true || payload.status === 'success' || response.status === 200;
					if (isSuccess) {
						// Prefer paginated array at data.data; fallback to plain data array
						const docs = Array.isArray(payload?.data?.data)
							? payload.data.data
							: (Array.isArray(payload?.data) ? payload.data : []);
						this.documents = docs;
					} else {
						this.showAlert("danger", payload.message || "Failed to fetch documents.");
						this.documents = [];
					}
					this.loading_page = false;
				},
				(error) => {
					this.showAlert("danger", error.message || "Error fetching documents.");
					this.documents = [];
					this.loading_page = false;
				}
			);
		},
		handleSearch() {
			this.page = 1;
			this.getDocuments(this.search);
		},
		downloadDocument(documentId, fileName) {
			console.log('Starting download for document:', documentId, 'with filename:', fileName);
			
			// Try download endpoint first, fallback to view endpoint if needed
			const downloadEndpoint = `documents/${documentId}/download`;
			
			UserService.authGetRequest(downloadEndpoint, {}, { responseType: 'blob' }).then(
				(response) => {
					console.log('Download response received:', response);
					console.log('Response data type:', typeof response.data);
					console.log('Response data size:', response.data ? response.data.size : 'no data');
					
					// Check if response has data
					if (!response.data) {
						console.error('No response data received');
						this.showAlert("danger", "No document data received from server.");
						return;
					}

					// Check if response data is empty
					if (response.data.size === 0) {
						console.error('Empty response data received');
						this.showAlert("danger", "Document is empty.");
						return;
					}

					console.log('Creating blob for download...');
					
					// Find the document to get proper MIME type
					const foundDocument = this.documents.find(doc => doc.id === documentId);
					const mimeType = foundDocument ? this.getFileType(foundDocument.file_name) : 'application/octet-stream';
					
					console.log('Using MIME type:', mimeType);
					console.log('Using filename:', fileName);
					
					// Create blob and download
					const blob = new Blob([response.data], { type: mimeType });
					console.log('Blob created, size:', blob.size);
					
					const url = window.URL.createObjectURL(blob);
					console.log('Blob URL created:', url);
					
					const link = document.createElement('a');
					link.href = url;
					link.download = fileName || 'document'; // Use .download instead of setAttribute
					link.style.display = 'none'; // Hide the link
					
					console.log('Appending link and triggering download...');
					document.body.appendChild(link);
					link.click();
					
					// Clean up
					setTimeout(() => {
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
						console.log('Download cleanup completed');
					}, 100);
				}
			).catch((error) => {
				console.error('Download endpoint failed, trying view endpoint:', error);
				
				// Fallback to view endpoint for download
				UserService.authGetRequest(`documents/${documentId}/view`, {}, { responseType: 'blob' }).then(
					(response) => {
						console.log('Fallback download response received:', response);
						
						if (!response.data || response.data.size === 0) {
							this.showAlert("danger", "Document is empty or not found.");
							return;
						}

						// Find the document to get proper MIME type
						const foundDocument = this.documents.find(doc => doc.id === documentId);
						const mimeType = foundDocument ? this.getFileType(foundDocument.file_name) : 'application/octet-stream';
						
						// Create blob and download
						const blob = new Blob([response.data], { type: mimeType });
						const url = window.URL.createObjectURL(blob);
						
						const link = document.createElement('a');
						link.href = url;
						link.download = fileName || 'document';
						link.style.display = 'none';
						
						document.body.appendChild(link);
						link.click();
						
						setTimeout(() => {
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
							console.log('Fallback download completed');
						}, 100);
					}
				).catch((fallbackError) => {
					console.error('Both download and view endpoints failed:', fallbackError);
					this.showAlert("danger", "Failed to download document. Please try again.");
				});
			});
		},
		viewDocument(documentId) {
			// Find the document to get its filename for MIME type detection
			const foundDocument = this.documents.find(doc => doc.id === documentId);
			const fileName = foundDocument ? foundDocument.file_name : '';
			const mimeType = this.getFileType(fileName);
			
			// Open in new tab via blob to include auth headers
			UserService.authGetRequest(`documents/${documentId}/view`, {}, { responseType: 'blob' }).then((response) => {
				// Check if response has data and is a blob
				if (!response.data || response.data.size === 0) {
					this.showAlert("danger", "Document is empty or not found.");
					return;
				}

				// Check if the response is actually an error message in JSON format
				if (response.data.type === 'application/json') {
					response.data.text().then(text => {
						try {
							const errorData = JSON.parse(text);
							this.showAlert("danger", errorData.message || "Failed to view document.");
						} catch (e) {
							this.showAlert("danger", "Failed to view document. Invalid response format.");
						}
					});
					return;
				}

				const blob = new Blob([response.data], { type: mimeType });
				const url = window.URL.createObjectURL(blob);
				
				// Check if the browser can display this type of file
				const viewableTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'text/plain'];
				
				if (viewableTypes.includes(mimeType)) {
					window.open(url, '_blank');
				} else {
					// For non-viewable types, offer download instead
					this.showAlert("info", "This file type cannot be viewed in browser. It will be downloaded instead.");
					
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fileName || 'document');
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
				
				// Clean up the URL after a delay
				setTimeout(() => window.URL.revokeObjectURL(url), 60 * 1000);
			}).catch((error) => {
				console.error('View error:', error);
				this.showAlert("danger", "Failed to view document. Please try again.");
			});
		}
	}
};
</script>

<style scoped>
.section-heading {
	padding: 10px 10px 0px 10px;
}
.custom-title {
	font-size: 22px;
	font-weight: 600;
}
.search-form {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 12px;
	width: 100%;
	max-width: 360px;
	margin-left: auto;
	margin-right: auto;
}
.search-input {
	min-width: 120px;
	flex: 1 1 0;
	border-radius: 8px;
	border: 1px solid #bfc4d4;
	padding: 8px 12px;
	font-size: 15px;
}
.search-button {
	border-radius: 8px;
	padding: 8px 18px;
	font-size: 15px;
	background: #2d3e8c;
	color: #fff;
	border: none;
	margin-left: 8px;
}
/* Use NotificationList styles for consistency */
.listview {
	margin-bottom: 20px;
}
.icon-box.bg-primary {
	background-color: #2d3e8c;
}
.badge-primary {
	background-color: #2d3e8c;
}
.document-actions {
	display: flex;
	gap: 8px;
	margin-top: 4px;
}
@media (max-width: 600px) {
	.search-form {
		max-width: 98vw;
	}
	.documents-list {
		align-items: center;
	}
	.document-card {
		padding: 10px 6px 8px 6px;
		max-width: 98vw;
		min-width: 0;
	}
	.doc-title {
		font-size: 16px;
	}
	.doc-desc {
		font-size: 13px;
	}
	.doc-btn {
		font-size: 14px;
		padding: 6px 12px;
	}
}
</style>
